import { render, staticRenderFns } from "./PolicyAssignRegisterTypes.vue?vue&type=template&id=0b698b74&scoped=true"
import script from "./PolicyAssignRegisterTypes.vue?vue&type=script&lang=js"
export * from "./PolicyAssignRegisterTypes.vue?vue&type=script&lang=js"
import style0 from "./PolicyAssignRegisterTypes.vue?vue&type=style&index=0&id=0b698b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b698b74",
  null
  
)

export default component.exports